import { Tooltip } from "@suraasa/placebo-ui"
import clsx from "clsx"
import React from "react"

import { formatTime } from "./utils"

interface TimeGraphProps {
  data: number[]
}

const TimeGraph: React.FC<TimeGraphProps> = ({ data }) => {
  const maxValue = Math.max(...data, 1)
  const zeroHeightPx = 5
  const containerHeightPx = 64

  return (
    <div className="relative flex h-8 items-end justify-between gap-0.5">
      {data.map((val, idx) => {
        let heightPx

        if (val === 0) {
          heightPx = zeroHeightPx
        } else {
          const proportionalHeight =
            (val / maxValue) * (containerHeightPx - zeroHeightPx)
          heightPx = proportionalHeight + zeroHeightPx
        }

        const barToolTipText = formatTime(val) === "_" ? "0m" : formatTime(val)

        return (
          <Tooltip
            key={idx}
            content={barToolTipText}
            className="flex h-full items-end"
          >
            <div
              className={clsx(
                "w-2.5 rounded-[5px] bg-gradient-to-b transition-all duration-500 ease-out",
                val === maxValue
                  ? " from-primary-500 via-primary-300 to-primary-500"
                  : " from-primary-500 to-primary-200"
              )}
              style={{ height: `${heightPx}px` }}
            />
          </Tooltip>
        )
      })}
    </div>
  )
}

export default TimeGraph
